<a class="branding" routerLink="/">
  @if (collapsed) {
    <img
      ngSrc="Reengage_Green.svg"
      class="branding-logo"
      alt="logo"
      width="32"
      height="32" />
  }
  @if (showName && !collapsed) {
    <img
      class="branding-name"
      [ngSrc]="wordLogo"
      alt="Word logo"
      height="167"
      width="999" />
  }
</a>
